// src/features/filtersSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const filtersSlice = createSlice({
  name: "filters",
  initialState: {
    page: 1,
    page_size: 10,
  },
  reducers: {
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    resetFilters: () => ({
      page: 1,
      page_size: 10,
    }),
  },
});

export const selectFilters = (state) => state.filters;
export const { setFilter, resetFilters } = filtersSlice.actions;
export default filtersSlice.reducer;
